import PropTypes from "prop-types";
import React from "react";

export const MoreHorizontal = props => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Icon/Overflow/Horiz Copy</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <path
        d="M6,10 C7.1,10 8,10.9 8,12 C8,13.1 7.1,14 6,14 C4.9,14 4,13.1 4,12 C4,10.9 4.9,10 6,10 Z M18,10 C19.1,10 20,10.9 20,12 C20,13.1 19.1,14 18,14 C16.9,14 16,13.1 16,12 C16,10.9 16.9,10 18,10 Z M12,10 C13.1,10 14,10.9 14,12 C14,13.1 13.1,14 12,14 C10.9,14 10,13.1 10,12 C10,10.9 10.9,10 12,10 Z"
        id="path-1"
      ></path>
    </defs>
    <g id="Icon/Overflow/Horiz-Copy" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <polygon id="Bounding-Box" points="0 0 24 0 24 24 0 24"></polygon>
      <mask id="mask-2" fill="white">
        <use xlinkHref="#path-1"></use>
      </mask>
      <use id="Shape" fill={props.fillColor} fillRule="nonzero" xlinkHref="#path-1"></use>
    </g>
  </svg>
);

MoreHorizontal.propTypes = {
  fillColor: PropTypes.string.isRequired,
};
